// GENERATED by scripts/encode-textures.mjs. Do not edit by hand.
// Basenames under public/textures/ with a WebP encode that is both
// >=15% smaller than the shipping JPEG and >=0.997 SSIM against it.
export const WEBP_TEXTURES = new Set([
  "earth_specular"
]);
